import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import combineStyles from '../../utils/combineStyles';
import ReferenceStyles from './__styles__/Reference.styles';
import TypographyStyles from '../../styles/typography';

export class Reference extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    details: PropTypes.string.isRequired
  };
  render() {
    const { classes, type, details = [] } = this.props;
    return (
      <div className={classes.root}>
        <h3 className={classes.subtitle2}>{type}</h3>
        <p
          className={classnames(
            classes.subtitle2,
            classes.content,
            classes.normalWeight
          )}
        >
          {details}
        </p>
      </div>
    );
  }
}
export default withStyles(combineStyles(ReferenceStyles, TypographyStyles))(
  Reference
);
